import {AfterContentInit, AfterViewChecked, AfterViewInit, Component, OnChanges, OnInit, SimpleChanges, ViewEncapsulation} from '@angular/core';
import {Alert} from '../../core/models/alert.model';
import {MatDialog} from '@angular/material/dialog';
import { NotificationService } from 'src/app/core/services/notification.service';
import { NotificationModalComponent } from 'src/app/core/components/notification-modal/notification-modal.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpClient } from '@angular/common/http';
import { Constant } from 'src/app/core/constant';
import { Utils } from 'src/app/core/utils';
import { WsNotificationsService } from 'src/app/core/services/websockets/ws-notifications.service';
import { WeetrustService } from 'src/app/core/services/weetrust.service';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { Router } from '@angular/router';
import { CompleteInfoPropertyComponent } from 'src/app/core/components/complete-info-property/complete-info-property.component';
import { CompleteInquilinoInfoComponent } from 'src/app/core/components/complete-inquilino-info/complete-inquilino-info.component';
import { take } from 'rxjs/operators';
import { LoadingComponent } from 'src/app/core/components/loading/loading.component';

@Component({
  selector: 'app-quick-panel',
  templateUrl: './quick-panel.component.html',
  styleUrls: ['./quick-panel.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class QuickPanelComponent implements OnInit, AfterViewChecked {
  public alerts: Array<Alert> = [];
  public getnotfication: boolean = false;

  constructor(
    private notificationService: NotificationService,
    private readonly snackBar: MatSnackBar,
    private readonly http: HttpClient,
    private readonly constant: Constant,
    private readonly dialog: MatDialog,
    private readonly wsNotifications: WsNotificationsService,
    private readonly weetrustService: WeetrustService,
    private readonly auth: AuthService,
    private readonly router: Router,
  ) {
    this.notificationService.alerts.subscribe(data => {
      this.alerts = data.filter(item => item.for_id == this.auth.idUser).sort((a, b) => a.created_at > b.created_at ? 0 : 1);
    });

    this.wsNotifications.notificationObservable.subscribe((data) => {
      if (data.for_id == this.auth.idUser) {
        const now = new Date();
        data.created_at = now.toISOString() as unknown as Date;
        data.id = parseInt(data.id.toString(), 10);
        this.notificationService.addAlert(data);
      }
    });
  }

  ngAfterViewChecked(): void {
    /*if (this.alerts.length <= 0 && !this.getnotfication) {
      this.getnotfication = true;
      this.notificationService.getNotifications().pipe((take(1))).subscribe(data => {
        const messages = data.map((alert: any) => ({
          id: alert.id,
          title: alert.title,
          message: alert.message.replaceAll('\n', '<br>'),
          shown: false,
          type: alert.type,
          property_id: alert.property_id,
          user_id: alert.user_to ?? alert.user_id,
          for_id: alert.f_action ?? alert.for_id,
          created_at: alert.created_at,
          advance_id: alert.advance_id,
          read: alert.read == 1
        } as Alert));

        this.alerts = messages.filter((item: any) => item.for_id == this.auth.idUser).sort((a: any, b: any) => a.created_at > b.created_at ? 0 : 1);
      }, (err) => {
        if (err.status != 401) {
          this.getnotfication = false;
        }
      });
    } else {
      this.alerts = this.notificationService.alerts.value;
    }*/
  }

  ngOnInit(): void {}
  
  acceptRequest(noti: Alert, accept: boolean): void {
    this.http.put(`${this.constant.api}property/request-rent/${noti.id}/accept`, {
      accept: accept
    }).subscribe((response) => {
      Utils.showMessage(this.snackBar, 'Success', 'Se ha enviado la notificación al inquilino.', 'success');
    }, err => {
      Utils.showMessage(this.snackBar, 'Error', 'Por favor intentelo mas tarde', 'error');
    });
  }

  public openNotification(noti: Alert): void {
    const notifications = this.notificationService.alerts.value;
    this.notificationService.alerts.next(notifications.map((item) => ({...item, read: noti.id == item.id ? true : item.read})));
    this.notificationService.readNotification(noti.id).subscribe(_ => {}, _ => {});
    const labels = this.getLabelsButtons(noti);

    const matdialog = this.dialog.open(NotificationModalComponent, {
      data: {
          noti: noti,
          cancelText: labels.cancel,
          acceptText: labels.accept
      }
    });

    matdialog.afterClosed().subscribe((response: {result: boolean, data: any, error: string | null}) => {
      if (response.result && noti.type == 7 && (noti.advance_id !== null && noti.advance_id > 0)) {
        this.weetrustService.contractSigning(response.data.signing_url);
      } else if (response.result && noti.type == 7 && (noti.property_id !== null && noti.property_id > 0)) {
        this.weetrustService.contractLeasing(response.data.signing_url);
      } else if (response.result && noti.type === 3 && (noti.property_id !== null && noti.property_id > 0)) {
        this.acceptRenta(noti);
      } else if (response.result && noti.type === 4 && (noti.property_id !== null && noti.property_id > 0)) {
        this.completeInquilinoInfo(noti);
      } else if (response.result && noti.type === 10 && (noti.advance_id !== null && noti.advance_id > 0)) {
        this.acceptCounteroffer(noti.advance_id, noti.id);
      } else if (response.result && noti.type == 11 && (noti.advance_id !== null && noti.advance_id > 0)) {
        this.getLocalization(noti.advance_id);
      } else if (response.result && noti.type == 8) {
        this.router.navigate(['/adelantos']);
      } else if (response.error !== null) {
        Utils.showMessage(this.snackBar, 'Error', response.error, 'error', 3500);
      }
    });
  }

  private getLabelsButtons(noti: Alert): {cancel: string, accept: string} {
    if (noti.type === 7) {
      return {cancel: 'Cerrar', accept: 'Firmar'};
    }

    if (noti.type === 3 && noti.property_id !== null) {
      return {cancel: 'Rechazar', accept: 'Aceptar'};
    }

    if (noti.type === 4 && noti.property_id !== null) {
      return {cancel: 'Cerrar', accept: 'Continuar'};
    }

    if (noti.type === 10 && noti.advance_id !== null) {
      return {cancel: 'Cerrar', accept: 'Aceptar'};
    }

    if (noti.type === 11 && noti.advance_id !== null) {
      return {cancel: 'Cerrar', accept: 'Confirmar'};
    }

    return {cancel: 'Cerrar', accept: 'Ok'};
  }

  private acceptRenta(noti: Alert): void {
    const dialog = this.dialog.open(CompleteInfoPropertyComponent, {
      data: {
        service: this.notificationService,
        user_id: noti.user_id,
        property_id: noti.property_id
      }
    });
  }

  private completeInquilinoInfo(noti: Alert): void {
    const dialog = this.dialog.open(CompleteInquilinoInfoComponent, {
      data: {
        service: this.notificationService,
        property_id: noti.property_id
      }
    });
  }

  private acceptCounteroffer(advanceId: number, notificationId: number): void {
    const dialog = this.dialog.open(LoadingComponent);

    this.notificationService.acceptCounteroffer(advanceId, notificationId).subscribe((response) => {
      dialog.close();
      if (response.status === 201) {
        Utils.showMessage(this.snackBar, 'Exitoso', 'Ya has respondido a esta contraoferta', 'success');
      } else {
        Utils.showMessage(this.snackBar, 'Exitoso', 'Tu respuesta fue enviada', 'success');
      }
    }, err => {
      dialog.close();
      Utils.showMessage(this.snackBar, 'Error', 'Por favor intentelo mas tarde', 'error');
    });
  }

  private getLocalization(advanceId: number): void {
    const dialog = this.dialog.open(LoadingComponent);

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((response) => {
        this.notificationService.confirmUbication(
          advanceId,
          response.coords.latitude,
          response.coords.longitude
        ).subscribe((response) => {
          dialog.close();
          Utils.showMessage(this.snackBar, 'Exitoso', 'Tu ubicación fue enviada', 'success');
        }, err => {
          dialog.close();
          Utils.showMessage(this.snackBar, 'Error', 'Por favor intentelo mas tarde', 'error');
        });
      });
    } else {
      Utils.showMessage(this.snackBar, 'Error', 'Es necesario aceptar los permisos de localización para realizar esta acción o intentar desde otro dispositivo', 'error');
    }
  }

}
